__turbopack_context__.v({
  "isActive": "presetTag-module-scss-module__zVw9bq__isActive",
  "presetTag": "presetTag-module-scss-module__zVw9bq__presetTag",
});
